<template>
  <div>
    <v-select
      v-model="selectedCountry"
      :label="$t('language.country')"
      :items="countries"
      :disabled="disabled"
      item-value="value"
      item-text="text"
      class="mb-5"
      outlined
    />
  </div>
</template>

<script>
import { countriesList } from '../../util/enums'

export default {
  props: {
    country: {
      type: String,
      default: 'BR',
      required: false,
    },

    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  computed: {
    selectedCountry: {
      get() {
        return this.country
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  data() {
    return {
      countries: countriesList.map((country) => {
        return {
          text: `${country.flag} ${country.country}`,
          value: country.value
        }
      })
    }
  }
}
</script>
